module.exports = __webpack_public_path__ + "static/media/arrow-down.a69b85f7.svg";